import { getCurrentIsoDate } from './string'

export const isPastDate = (dateTime: string, defaultValue: boolean = false) => {
  try {
    return new Date(getCurrentIsoDate()).getTime() > new Date(dateTime).getTime()
  } catch (error) {
    console.error(error)
    return defaultValue
  }
}

export const addYearToTimestamp = (dateTime: string): string => {
  try {
    const plusYear = new Date(dateTime)
    plusYear.setFullYear(plusYear.getFullYear() + 1)
    return plusYear.toISOString()
  } catch (error) {
    console.error(error)
    return dateTime
  }
}

export const isValidDate = (d: Date): boolean => {
  //@ts-expect-error Typescript does not understand that isNaN workds for dates
  return d instanceof Date && !isNaN(d)
}

export const backendTimeToLocalTime = (backendDate: string | undefined): string => {
  if (backendDate === undefined || (backendDate ?? '').length < 10) return '-'
  try {
    const isoUtc = backendDate.trim().replace(' ', 'T') + (backendDate.trim().indexOf('Z') > 0 ? '' : 'Z')
    const date = new Date(isoUtc)
    return date.toLocaleString()
  } catch (e) {
    return '-'
  }
}
